module.exports = __webpack_public_path__ + "img/multipleProfile.8e2c40c5.png";